import React, { useState, useEffect } from "react";
import styles from "./styles/Today.module.css";
import { useItemsFine } from "../_actions/app/items";
import log from "cslog";
import dayjs from "dayjs";
// import CalendarCard from "../content_calender_new/SocialMediaCards";
import IdeaCanvasBox from "../content_calender_new/IdeaCanvasBox";
import IdeaCanvasModal from "../content_calender_new/IdeaCanvasModal";
import CalendarCardsRenderer from "../content_calender_new/CalendarCardRenderer";
import {
    processEvents,
    processEntries,
} from "../content_calender_new/ContentCalenderNew";
import { useMedia } from "react-use";
import { Button, Skeleton, Space, Spin } from "antd";
import {
    BulbOutlined,
    DotChartOutlined,
    LeftOutlined,
    RightOutlined,
    PlusOutlined,
} from "@ant-design/icons";

function OneDay({
    me = {},
    date,
    showHeader = false,
    onDateChange,
    padding_x = 15,
    padding_y = 15,
    border = true,
    items,
    onAddClick,
}) {
    // fix: ensure dayjs() is called
    const [current, setCurrent] = useState(() =>
        date ? dayjs(date) : dayjs()
    );
    useEffect(() => {
        if (date) setCurrent(dayjs(date));
    }, [date]);
    const base = showHeader ? current : date ? dayjs(date) : dayjs();
    const today_start = base.startOf("day");
    const today_end = base.endOf("day");
    const range = [today_start, today_end];
    const isMobile = useMedia("(max-width:800px)");
    // modal state handled by CalendarCardsRenderer now
    // const [open, setOpen] = useState(false);
    // const [selected_card, setSelectedCard] = useState(null);

    const now = dayjs().startOf("day");
    const headingText = base.isSame(now.subtract(1, "day"), "day")
        ? `Yesterday, ${base.format("MMM D, YYYY")}`
        : base.isSame(now, "day")
        ? `Today, ${base.format("MMM D, YYYY")}`
        : base.isSame(now.add(1, "day"), "day")
        ? `Tomorrow, ${base.format("MMM D, YYYY")}`
        : base.format("dddd, MMM D, YYYY");

    const {
        isSuccess: successEvent,
        isFetching: loadingEvent,
        data: dataEvent,
    } = useItemsFine(
        "qdb_event",
        // "filter[status][_eq]=published&filter[date][_between]=",
        `fields=id,date,name,event_type,primary_tag.name,primary_tag.id,feature_image&filter=${JSON.stringify(
            {
                status: { _eq: "published" },
                date: { _between: range },
                star: { _in: [1, 2, 3, 4, 5] },
                event_type: { _eq: "festival" },
            }
        )}`,
        !items,
        false
    );

    log.d(dataEvent, "dataEvents in Today");
    // const {
    //     isSuccess: successUserEvent,
    //     isFetching: loadingUserEvent,
    //     data: dataUserEvent,
    // } = useItemsFine(
    //     "qdb_event",
    //     // "filter[status][_eq]=published&filter[date][_between]=",
    //     `fields=id,date,name,event_type,feature_image&filter=${JSON.stringify({
    //         status: { _eq: "published" },
    //         date: { _between: range },
    //         event_type: { _eq: "user_created" },
    //     })}`,
    //     true,
    //     false
    // );
    // log.d(dataUserEvent, "dataUserEvents in Today");
    const {
        isSuccess: successCalEntry,
        isFetching: loadingCalEntry,
        data: dataCalEntry,
    } = useItemsFine(
        "qdb_calendar_entries",
        `fields=*,platforms.*&filter=${JSON.stringify({
            organization: { _eq: me.selected_org?.id },
            date: { _between: range },
        })}`,
        !items,
        false
    );
    log.d(dataCalEntry, "dataUserEvents in Today");
    // useEffect(() => {
    //     if (successCalEntry && dataCalEntry) {
    //         setEntryItems(processCalEntries(dataCalEntry));
    //     }
    // }, [successCalEntry, dataCalEntry]);

    const eventItems = successEvent && !items ? processEvents(dataEvent) : {};
    const entryItems =
        successCalEntry && !items ? processEntries(dataCalEntry) : {};
    const eventsForDay =
        eventItems[today_start.month()]?.[today_start.date()] || [];
    const entriesForDay =
        entryItems[today_start.month()]?.[today_start.date()] || [];
    const itemsForDay = items || [...entriesForDay, ...eventsForDay];
    const onNav = (delta) => {
        const next = base.add(delta, "day");
        setCurrent(next);
        onDateChange?.(next);
    };
    return (
        <div
            className={showHeader ? styles.wrapper : undefined}
            style={{ border: border ? "1px solid #0000001e" : "none" }}
        >
            {showHeader ? (
                <div
                    className={styles.header}
                    style={{ padding: `10px ${padding_x}px` }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                        }}
                    >
                        <Space.Compact size={isMobile ? "small" : "middle"}>
                            <Button
                                shape="circle"
                                type="text"
                                icon={<LeftOutlined />}
                                onClick={() => onNav(-1)}
                                aria-label="Previous day"
                            />
                            <Button
                                shape="circle"
                                type="text"
                                icon={<RightOutlined />}
                                onClick={() => onNav(1)}
                                aria-label="Next day"
                            />
                        </Space.Compact>
                        <div className={styles.header_title}>
                            {/* {base.format(
                                isMobile ? "D MMM YYYY" : "dddd, MMMM D, YYYY"
                            )} */}
                            {headingText}
                        </div>
                        {(loadingCalEntry || loadingEvent) && (
                            <Spin size="small" />
                        )}
                    </div>
                </div>
            ) : (
                // No header in calendar usage, but keep a small placeholder spinner if loading
                (loadingCalEntry || loadingEvent) && (
                    <div style={{ padding: "4px 0" }}>
                        <Spin size="small" />
                    </div>
                )
            )}

            <div
                className={styles.content}
                style={{ padding: `${padding_y}px ${padding_x}px` }}
            >
                {/* <div className={styles.cards_wrapper}> */}
                {(loadingCalEntry || loadingEvent) && (
                    <div style={{ display: "flex", gap: "20px" }}>
                        {Array.from({ length: 3 }).map((_, i) => (
                            <Skeleton.Node
                                active={true}
                                style={{ width: "200px", height: "200px" }}
                            >
                                <BulbOutlined
                                    style={{ fontSize: 40, color: "#bfbfbf" }}
                                />
                            </Skeleton.Node>
                        ))}
                    </div>
                )}
                <CalendarCardsRenderer
                    items={itemsForDay}
                    me={me}
                    isMobile={isMobile}
                    collapsible={true}
                    className={styles.cards_wrapper}
                    rowStyle={true}
                />
                <div
                    className={styles.cellAddButtonRow}
                    style={{
                        paddingTop: "8px",
                    }}
                >
                    <Button
                        block
                        size="small"
                        type="dashed"
                        icon={<PlusOutlined style={{ color: "#1ba698" }} />}
                        className={styles.cellAddButton}
                        onClick={onAddClick}
                        aria-label="Add"
                    />
                </div>
                {/* </div> */}
            </div>
        </div>
    );
}

export default OneDay;
